export const useFileSaver = () => {
    function save(data: string, fileName: string = 'document') {
        const blob = new Blob([data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        URL.revokeObjectURL(link.href)
    }

    return {save}
}